<template>
    <div class="d-inline-block" data-testid="activity-log-new">
        <div class="" data-testid="activity-log-new__header">
            <v-btn
                data-testid="activity-log-new__open-btn"
                v-bind="attrs"
                v-on="on"
                name="activity-log"
                @click.stop="dialog = true; loadData();"
                icon
            >
                <v-icon data-testid="activity-log-new__icon-history">mdi-history</v-icon>
            </v-btn>
            <span class="mr-1" data-testid="activity-log-new__title" @click.stop="dialog = true; loadData();">{{ name }}</span>
        </div>
        <lb-dailogboxnew
            v-model="dialog"
            :heading="heading"
            :width="width"
            :loading="loading"
            data-testid="activity-log-new__dialog"
        >
            <template v-slot:body>
                <div v-if="loglist.length > 0" style="max-height: 500px; overflow-y:auto" data-testid="activity-log-new__list">
                    <span class="font-weight-bold lightgrey--text" data-testid="activity-log-new__recent-label">Recent</span>
                    <div v-for="(v, k) in loglist" :key="k" data-testid="activity-log-new__item">
                        <div class="d-flex my-1  pa-2  hoverable align-start" data-testid="activity-log-new__item-row">
                            <div class="font-size-md line-1 border-on pa-2" data-testid="activity-log-new__item-img-container">
                                <img :src="(config[v.type] || {}).src" data-testid="activity-log-new__item-img"/>
                            </div>
                            <div class="ml-2" style="width:100%;" data-testid="activity-log-new__item-details">
                                <div class="d-flex justify-space-between align-center line-1-2" data-testid="activity-log-new__item-meta">
                                    <div label class="font-weight-bold" data-testid="activity-log-new__item-title">{{ v.text || (config[v.type] || {}).displaytext || v.type }}</div>
                                    <div style="font-size:0.65rem  !important;" class="lightgrey--text" data-testid="activity-log-new__item-date">{{
                                        $nova.formatDateTime((new Date(v.created_at)), "DD MMM yyyy hh:mm A") }}</div>
                                </div>
                                <div class="lightgrey--text" data-testid="activity-log-new__item-username">{{ (v.userid_detail || {}).name }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="grey--text py-4 text-center font-size-lg" v-else data-testid="activity-log-new__empty-state">
                    No Log Available
                </div>
            </template>
        </lb-dailogboxnew>
    </div>
</template>

<script>
export default {
    data: function () {
        return {
            dialog: false,
            loading: false,
            loglist: [],
        };
    },
    // created() {
    //   this.refreshData();
    // },
    // activated() {
    //   this.refreshData();
    // },

    props: {
        heading: {
            type: String,
            default: 'Activity Log',
        },
        width: {
            type: String,
            default: '600',
        },
        url: {
            type: String,
        },
        config: {
            default: {}
        },
        contentClass: {
            type: String,
            default: 'tooltip-bottom'
        },
        name:
        {
            type: String,
            default:""
        }
    },

    methods: {
        loadData() {
            this.loading = true;
            this.loglist = [];
            if (this.url) {
                this.axios.post(this.url).then(dt => {
                    if (dt.data.status === "success") {
                        this.loglist = dt.data.data;
                        // console.log(this.loglist);
                    } else throw new Error("Error loading information");
                }).catch(err => {
                    this.$store.commit("sbError", err.message || err || "Unknown error!");
                    console.log(err);
                }).finally(() => {
                    this.loading = false;
                })
            }
        },
    }
};
</script>

<style scoped>
.timeline-line {
    min-width: 3px;
    max-width: 3px;
}
</style>